import * as moment from 'moment';
import { Moment } from 'moment';
import SectorOfInterest from 'src/entities/SectorOfInterest';
import QuarterlyReport from 'src/entities/QuarterlyReport';

export default class Company {
  id: number;
  name: string;
  cif?: string;
  description: string;
  logo?: string;
  website?: string;
  email?: string;
  phoneNumber?: string;
  address?: string;
  city?: string;
  zipCode?: string;
  province?: string;
  country?: string;
  establishmentDate?: Moment;
  iban?: string;
  swiftBic?: string;
  sectorsOfInterest: SectorOfInterest[];
  founderId?: number;
  contactName?: string;
  contactSurname?: string;
  contactNationality?: string;
  contactNif?: string;
  contactBirthDate?: Moment;
  contactEmail?: string;
  contactPhoneNumber?: string;
  contactAddress?: string;
  contactZipCode?: string;
  contactCity?: string;
  contactProvince?: string;
  contactCountry?: string;
  statutes?: string;
  statutesImage?: string;
  quarterlyReports?: QuarterlyReport[];

  constructor(entity: Company) {
    this.id = entity.id;
    this.name = entity.name;
    this.cif = entity.cif || undefined;
    this.description = entity.description;
    this.logo = entity.logo || undefined;
    this.website = entity.website || undefined;
    this.email = entity.email || undefined;
    this.phoneNumber = entity.phoneNumber || undefined;
    this.address = entity.address || undefined;
    this.city = entity.city || undefined;
    this.zipCode = entity.zipCode || undefined;
    this.province = entity.province || undefined;
    this.country = entity.country || undefined;
    this.establishmentDate = entity.establishmentDate ? moment.utc(entity.establishmentDate) : undefined;
    this.iban = entity.iban || undefined;
    this.swiftBic = entity.swiftBic || undefined;
    this.sectorsOfInterest = entity.sectorsOfInterest ?
      entity.sectorsOfInterest.map(sector => new SectorOfInterest(sector)) :
      [];
    this.founderId = entity.founderId;
    this.contactName = entity.contactName || undefined;
    this.contactSurname = entity.contactSurname || undefined;
    this.contactNationality = entity.contactNationality || undefined;
    this.contactNif = entity.contactNif || undefined;
    this.contactBirthDate = entity.contactBirthDate ? moment.utc(entity.contactBirthDate) : undefined;
    this.contactEmail = entity.contactEmail || undefined;
    this.contactPhoneNumber = entity.contactPhoneNumber || undefined;
    this.contactAddress = entity.contactAddress || undefined;
    this.contactZipCode = entity.contactZipCode || undefined;
    this.contactCity = entity.contactCity || undefined;
    this.contactProvince = entity.contactProvince || undefined;
    this.contactCountry = entity.contactCountry || undefined;
    this.statutes = entity.statutes || undefined;
    this.statutesImage = entity.statutesImage || undefined;
    this.quarterlyReports = entity.quarterlyReports ?
      entity.quarterlyReports.map(quarterlyReport => new QuarterlyReport(quarterlyReport)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/entities/Company.tsx